var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartPurpleFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.152,
    height: 23.267,
    viewBox: "0 0 26.152 23.267",
    fill: "#832EE6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#832EE6",
    id: "heart",
    d: "M13.076,23.267a1.534,1.534,0,0,1-1.011-.38c-1.056-.924-2.075-1.792-2.974-2.558l0,0a55.307,55.307,0,0,1-6.493-6.094A9.734,9.734,0,0,1,0,7.86,8.174,8.174,0,0,1,2.075,2.277,7.032,7.032,0,0,1,7.306,0a6.578,6.578,0,0,1,4.109,1.418,8.407,8.407,0,0,1,1.661,1.735,8.408,8.408,0,0,1,1.661-1.735A6.578,6.578,0,0,1,18.847,0a7.033,7.033,0,0,1,5.231,2.277A8.174,8.174,0,0,1,26.152,7.86a9.733,9.733,0,0,1-2.594,6.371,55.3,55.3,0,0,1-6.492,6.094A26.539,26.539,0,0,1,13.076,23.267Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPurpleFull);
export default __webpack_public_path__ + "static/media/heart-purple-full.73c24549f88569a8cdc24253f9764588.svg";
export { ForwardRef as ReactComponent };